module.exports = __webpack_public_path__ + "static/media/music1.f6aa6c7a.mp3";